import React from 'react';
import './Overlay.css'

function Overlay() {

  return (
    <div className='Background'>
        {/* <div className='Slider'></div> */}
        <div className='Square top'></div>
        <div className='Square bottom'></div>
        <h1 className='Title'>MaxiM</h1>   
    </div>
  )
}

export default Overlay